import {
  Breakpoints,
  Button,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import React from 'react';

import { getCTATooltipTextForBlockedUser } from '../../utils/coach';
import SvgIcon, { Svg } from '../SvgIcon';

interface CustomPackageWidgetProps {
  coachFirstName: string;
  onClick: () => void;
  blocked?: boolean;
}

const CustomPackageWidget: React.FC<CustomPackageWidgetProps> = ({
  onClick,
  coachFirstName,
  blocked,
}) => {
  const isMdOrLarger = useMediaQuery(Breakpoints.MD);
  const blockedUserCTAText = getCTATooltipTextForBlockedUser(coachFirstName);

  const content = (
    <div className="flex flex-row items-center md:flex-col">
      <SvgIcon
        className="mx-7 size-8 shrink-0 self-center text-leland-blue md:mx-0"
        svgType={Svg.CUSTOM_PACKAGE}
      />
      <div className="flex grow flex-col">
        <p className="text-sm font-semibold tracking-wider text-leland-blue md:mt-5 md:uppercase">
          Need a custom package?
        </p>
        <h2 className="mt-1 text-lg font-medium leading-snug text-leland-gray-dark md:mt-2 md:text-xl md:font-normal">
          Let {coachFirstName} create the perfect package for you.
        </h2>
      </div>
      {isMdOrLarger ? (
        <div className="mt-6 block">
          <Button
            label="Get started"
            disabled={blocked}
            tooltipContent={blocked ? blockedUserCTAText : null}
            onClick={onClick}
            id="custom_package_widget:get_started"
          />
        </div>
      ) : null}
    </div>
  );

  const containerClassName =
    'flex flex-col justify-center rounded-md border border-leland-gray-stroke p-4 pl-2 shadow-sm md:cursor-default md:items-center md:p-6 md:text-center';

  return isMdOrLarger ? (
    <div className={containerClassName}>{content}</div>
  ) : (
    <button
      className={containerClassName}
      disabled={blocked}
      onClick={onClick}
      id="custom_package_widget:get_started"
    >
      {content}
    </button>
  );
};

export default CustomPackageWidget;
